import {Vue} from 'ui.vue';


import './BXmakerAuthuseremailAuthorized.css';

Vue.component('BXmakerAuthuseremailAuthorized',
    {
        template: `
            <div class="bxmaker-authuseremail-authorized-block"  >
               {{$root.localize.BXMAKER_AUTHUSEREMAIL_IS_AUTHORIZED}}
            </div>
        `,
    });